import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';

import '../../styles/game/Chat.css';
// src/socket.js
import { io } from "socket.io-client";
import { useSocket } from '../../providers/SocketContext.jsx'
import { useAuth } from '../../providers/AuthProvider.jsx';
import EmojiPicker, { EmojiStyle, Categories, SuggestionMode } from "emoji-picker-react";
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
const gf = new GiphyFetch('vXiPw0ZWnXS991Or3iOcxJ4hlydcAShX');
import { t } from "i18next";

function Chat({ setChatBar }) {
    const socket = useSocket()
    const [message, setMessage] = useState("")
    const [showPicker, setShowPicker] = useState(false)
    const [online, setOnline] = useState(0)
    const onEmojiClick = (emojiObject) => {
        setMessage((prevMessage) => prevMessage + emojiObject.emoji);
      };

      useEffect(() => {
        if(socket) {
            socket.on('get_players_online', (playersOnline) => {
                setOnline(playersOnline)
            })
        }

        if(socket) {
            return () => {
                socket.off('get_players_online');
            }
        }
      }, [socket])

      useEffect(() => {
        if(!socket) {
            return
        }

        socket.emit('get_online')
        socket.on('render_online', (online) => {
            setOnline(online)
        })

        return () => {
            socket.off('render_online', online);
        }
      }, [socket])




    function TextMessage({ text }) {
        

        return (
            <div className={'chat-bar-message-wrap'}>
                <div className={'chat-bar-text-message-wrap'}>
                    <div className={'chat-bar-message-avatar'}>
                        <img width={22} src="/assets/img/avatars/av-1.png" alt="" />
                    </div>
                    <div className={'chat-bar-msg-wrap'}>
                        <div className={'chat-bar-msg-data'}>
                            <span className={'chat-bar-user-name'}>8***6</span>
                            {text ? text : <span>buxquen a jaqueline gutierrez da buenas predicciones</span>}
                        </div>
                        
                    </div>
                    <div className={'chat-bar-likes-block'}> <img width={12} src="/assets/img/main/like-avia.svg" alt="" /> </div>
                </div>
            </div>
        )
    }

    function BanMessage() {

        return (
            <div className={'chat-bar-message-wrap  ban-message'}>
                <div className={'chat-bar-text-message-wrap ban-message'}>
                    <div className={''}>
                        <div className={'chat-bar-msg-data'}>
                            <span className={'chat-bar-user-name ban-message'}>6***7</span>
                            <span style={{"color": "white"}}><span style={{"fontWeight": "bold"}}>был заблокирован</span> в чате на 6944 д 10 ч 39 м. Причина: Спам</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    function WinMessage({ text }) {


        return (
            <div style={{"borderRadius": "6px", 'backgroundColor': '#34002f'}} className={'chat-bar-message-wrap win-info'}>
                <div style={{"paddingTop": "10px", "minHeight": "40px", "background": "rgba(0,0,0,.2)", "borderRadius": "0"}} className={'chat-bar-text-message-wrap'}>
                    <div className={'chat-bar-message-avatar'}>
                        <img width={22} src="/assets/img/avatars/av-1.png" alt="" />
                    </div>
                    <div className={'chat-bar-msg-wrap'}>
                        <div className={'chat-bar-msg-data'}>
                            <span className={'chat-bar-user-name'}>8***6</span>
                            {text ? text : <span>buxquen a jaqueline gutierrez da buenas predicciones</span>}
                        </div>
                        
                    </div>
                    <div className={'chat-bar-likes-block'}> <img width={12} src="/assets/img/main/like-avia.svg" alt="" /> </div>
                </div>
                <div className={'chat-bar-win-info'}>
                    <div className={'chat-bar-win-info-header'}></div>
                    <div className={'chat-bar-win-info-user'}>
                        <img style={{"margin": "0 5px 0 2px"}} width={22} src="/assets/img/avatars/av-15.png" alt="" />
                        <div>7***3</div>
                    </div>
                    <div className={'chat-bar-win-info-blocks'}>
                        <div style={{'width': '50%', 'fontSize': '12px', 'flexShrink': '0', 'paddingLeft': '12%'}}>
                            <p style={{'opacity': '0.3', 'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px'}}>Выведено средств:</p>
                            <p style={{'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px', 'marginTop': '5px', 'color': 'rgb(192, 23, 180)', 'fontWeight': '700'}}>250,000.00x</p>
                        </div>
                        <div style={{'width': '50%', 'fontSize': '12px', 'flexShrink': '0', 'paddingLeft': '12%'}}>
                            <p style={{'opacity': '0.3', 'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px'}}>Выигрыш, UZS:</p>
                            <p style={{'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px', 'marginTop': '5px', 'color': '#fff'}}>250,000,000.00</p>
                        </div>
                    </div>
                    <div className={'chat-bar-win-info-blocks'}>
                    <div style={{'width': '50%', 'fontSize': '12px', 'flexShrink': '0', 'paddingLeft': '12%'}}>
                            <p style={{'opacity': '0.3', 'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px'}}>Раунд:</p>
                            <p style={{'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px', 'marginTop': '5px', 'color': '#fff',}}>250,000.00x</p>
                        </div>
                        <div style={{'width': '50%', 'fontSize': '12px', 'flexShrink': '0', 'paddingLeft': '12%'}}>
                            <p style={{'opacity': '0.3', 'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px'}}>Ставка, UZS:</p>
                            <p style={{'display': 'flex', 'justifyContent': 'flex-start', 'alignItems': 'center', 'height': '14px', 'marginTop': '5px', 'color': '#fff'}}>250,000,000.00</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const GifSearch = () => {
        const [gifs, setGifs] = useState([]);
        const [searchQuery, setSearchQuery] = useState(''); // Начальный запрос
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(null);
        const [selectedGif, setSelectedGif] = useState(null);  // Для хранения выбранной гифки
      
        const apiKey = '4hKShKIvhXjlvkEEWfsD7RVXbVKIFNUk';  // Замените на ваш реальный API ключ
      
        const fetchGifs = async (query = 'aviator game') => {
          setLoading(true);
          setError(null); // Сброс ошибки при новом запросе
      
          try {
            const response = await fetch(`https://api.giphy.com/v1/gifs/search?q=${query}&api_key=${apiKey}&limit=10&offset=0`);
      
            // Проверка на успешность запроса
            if (!response.ok) {
              throw new Error('Ошибка при загрузке данных');
            }
      
            const data = await response.json();
            setGifs(data.data); // Сохраняем полученные гифки
          } catch (err) {
            setError('Ошибка загрузки данных');
          } finally {
            setLoading(false);
          }
        };
      
        // Используем useEffect для первоначальной загрузки гифок
        useEffect(() => {
          fetchGifs(searchQuery === '' ? 'aviator money cash' : searchQuery);
        }, [searchQuery]);  // Запрос будет выполняться при изменении searchQuery
      
        // Обработчик изменения текста в input
        const handleSearchChange = (e) => {
          setSearchQuery(e.target.value);
        };
      
        // Обработчик клика по гифке
        const handleGifClick = (gif) => {
          setSelectedGif(gif); // Сохраняем выбранную гифку в состояние
          console.log('Выбранная гифка:', gif); // Для отладки, можно использовать для отправки в чат
        };
      
        return (
          <div style={{'backgroundColor': '#1b1c1d', 'width': '300px', 'borderRadius': '8px', 'position': 'absolute', 'bottom': '62px',}}> 
                            <div style={{'height': '36px', 'display': 'flex', 'backgroundColor': '#2c2d30', 
                'alignItems': 'center', 'borderTopLeftRadius': '8px', 'borderTopRightRadius': '8px', 
                'padding': '0 10px 0 10px', 'color': '#fff',}}> <p style={{'fontWeight': 'normal !important', 'fontSize': '16px'}}>EMOJI</p> 
                <button className={'emoji-wrapper-close-button'} onClick={() => setGifPicker(false)}>×</button>
                </div>
            <div className={'gif-search-input-wrapper'}>
            <input
              type="text"
              placeholder="Search gif..."
              value={searchQuery}
              onChange={handleSearchChange}
              className={'gif-search-input'}
            />
            </div>
      
            {loading && <p>Загрузка...</p>}
            {error && <p>{error}</p>}
            
            <div className="gif-grid">
              {gifs.length > 0 ? (
                gifs.map((gif) => (
                  <div className={'gifs-wrapper'} key={gif.id} onClick={() => handleGifClick(gif)}>
                    <img src={gif.images.fixed_height.url} alt={gif.title} />
                  </div>
                ))
              ) : (
                <p>Гифки не найдены</p>
              )}
            </div>
      
            {/* Выводим выбранную гифку для проверки */}
            {/* {selectedGif && (
              <div>
                <h2>Выбранная гифка:</h2>
                <img src={selectedGif.images.fixed_height.url} alt={selectedGif.title} />
              </div>
            )} */}
          </div>
        );
      };
      

      function SpamFilter({setIsSpamActive}) {

        const handleAnimationEnd = () => {
            setIsSpamActive(false); // Устанавливаем скрытие
          };
        
        return (
            <div className={'chat-bar-spam-wrapper'}>
            <div className={'spam-filter-loading'}>
                <div className={'spam-time-left-loading'} onAnimationEnd={handleAnimationEnd}></div>
            </div>
            <p className={'spam-filter-text'}>Спам-фильтр...</p>
        </div>
        )
      }

      const [isSpamActive, setIsSpamActive] = useState(false)

      const [gifPicker, setGifPicker] = useState(false)

      const [chatMessagesArray, setChatMessagesArray] = useState([
        <TextMessage />,
        <TextMessage text={'text text'} />,
        <BanMessage />,
        <WinMessage text={''} />,
      ])


    return (
        <>
            <div className={'chat-bar-wrapper'}>
                <div className={'chat-bar-header'}>
                    <div className={'chat-bar-header-container'}>
                        <div className={'chat-bar-header-online'}> <div className={'chat-bar-online-circle'}></div>{online ? online : 0}</div>
                        <div className={'chat-bar-close-button'} onClick={() => setChatBar(false)}>×</div>
                    </div>
                </div>
                <div className={'chat-bar-messages-container'}>
                    <div className=""></div>
                    {/* <TextMessage />
                    <TextMessage text={'text text'} />
                    <BanMessage />
                    <WinMessage text={''} /> */}
                    
                    {/* <ChatWithEmojiPicker /> */}
                    {chatMessagesArray.map((item, index) => (
                        <div key={index}>
                            {item}
                        </div>
                    ))}
                </div>
                <div className={'chat-bar-input-message-wrapper'}>
                    <textarea 
                    className={'chat-bar-input-area'} 
                    name="" id="" minLength={1} 
                    placeholder={t("reply")} 
                    maxLength={160} required={""} 
                    cols="30" 
                    rows="10"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                    <div className={'chat-bar-input-tools'}>
                        <div className={'chat-bar-smiley-emoji'} onClick={() => {
                            setShowPicker((prev) => !prev)
                            setGifPicker(false)
                        }}></div>
                        <div style={{"margin-left": "5px"}} className={'chat-bar-gif'} onClick={() => {
                            setGifPicker((prev) => !prev)
                            setShowPicker(false)
                        }}></div>
                        <div className={'chat-bar-input-length'}>{160 - message.length}</div>
                        {showPicker && (
              <div className="emoji-picker-wrapper">
                <div style={{'height': '36px', 'display': 'flex', 'backgroundColor': '#2c2d30', 
                'alignItems': 'center', 'borderTopLeftRadius': '8px', 'borderTopRightRadius': '8px', 
                'padding': '0 10px 0 10px', 'color': '#fff',}}> <p style={{'fontWeight': 'normal !important', 'fontSize': '16px'}}>EMOJI</p> 
                <button className={'emoji-wrapper-close-button'} onClick={() => setShowPicker(false)}>×</button>
                </div>
                <EmojiPicker 
                onEmojiClick={onEmojiClick} 
                emojiStyle='native' 
                theme='dark' 
                className={'emoji-picker-container'}
                categories={[
                    {
                        category: "suggested",
                        name: "Избранный"
                    },
                    {
                        category: "smileys_people", // ID категории
                        name: "Люди и смайлы",
                    },
                    {
                        category: "animals_nature",
                        name: 'Nature'
                    },
                    {
                        category: "objects",
                        name: 'Objects'
                    },
                    {
                        category: "travel_places",
                        name: 'Places'
                    },
                    {
                        category: "symbols",
                        name: 'Symbols'
                    },
                ]}
                searchPlaceHolder={'Search emoji...'}
                proposedEmojisMode='frequent'
                />
              </div>
            )}
            {gifPicker && <GifSearch />}
                    </div>
                    <div className={`chat-bar-enter-button ${message.length > 0 ? "active" : ""}`} onClick={() => {
                        if(!message) {
                            return
                        }
                        setChatMessagesArray((prev) => [
                            ...prev,
                            <TextMessage text={message} />
                        ])
                        setIsSpamActive(true)
                        setMessage("")
                    }}></div>
                    {isSpamActive && <SpamFilter setIsSpamActive={setIsSpamActive} />}
                </div>
            </div>
        </>
    )
}

export default Chat;